// extracted by mini-css-extract-plugin
var _1 = "LandingFooterNavigation_root__ef5d7";
export { _1 as "root" }
